var map = {
	"./majorA1.wav": "Uhhf",
	"./majorA2.wav": "/QCr",
	"./majorA3.wav": "/4sn",
	"./majorA4.wav": "S8eu",
	"./majorA5.wav": "Y2Q3",
	"./majorA6.wav": "Qw/e",
	"./majorA7.wav": "GItl",
	"./majorB1.wav": "8T+c",
	"./majorB2.wav": "CSmY",
	"./majorB3.wav": "D63k",
	"./majorB4.wav": "8wED",
	"./majorB5.wav": "mLKa",
	"./majorB6.wav": "OXkW",
	"./majorB7.wav": "jY2c",
	"./majorC1.wav": "Pqa1",
	"./majorC2.wav": "vDQF",
	"./majorC3.wav": "+CU1",
	"./majorC4.wav": "0XE8",
	"./majorC5.wav": "KQ7j",
	"./majorC6.wav": "81w/",
	"./majorC7.wav": "R4lq",
	"./majorD1.wav": "byR7",
	"./majorD2.wav": "AOFL",
	"./majorD3.wav": "l7/M",
	"./majorD4.wav": "8RU4",
	"./majorD5.wav": "GMjL",
	"./majorD6.wav": "OgLN",
	"./majorD7.wav": "ULqa",
	"./majorE1.wav": "1fGi",
	"./majorE2.wav": "tso0",
	"./majorE3.wav": "M4Nm",
	"./majorE4.wav": "IZuE",
	"./majorE5.wav": "mQ56",
	"./majorE6.wav": "T5W5",
	"./majorE7.wav": "wcc8",
	"./majorF1.wav": "WVd4",
	"./majorF2.wav": "Wchq",
	"./majorF3.wav": "zYQS",
	"./majorF4.wav": "hnS/",
	"./majorF5.wav": "EGKx",
	"./majorF6.wav": "eZIH",
	"./majorF7.wav": "eWUq",
	"./majorG1.wav": "AYvt",
	"./majorG2.wav": "HyAv",
	"./majorG3.wav": "yfCy",
	"./majorG4.wav": "cFix",
	"./majorG5.wav": "wmvI",
	"./majorG6.wav": "AA/S",
	"./majorG7.wav": "Y3qO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "al/9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing ^\.\/major.*\.wav$
// module id = al/9
// module chunks = 0